import {
  formatSimpleDate,
  toCurrency,
  formatMarketCap,
} from "../utils/searchUtils";
import { Link as ReactRouterLink } from "react-router-dom";

const getInstitutionTypeIcon = (type) => {
  switch (type?.toLowerCase()) {
    case "listed":
      return "fa-chart-line";
    case "super":
      return "fa-piggy-bank";
    case "private":
      return "fa-lock";
    case "government":
      return "fa-landmark";
    case "nfp":
      return "fa-heart";
    default:
      return "fa-building";
  }
};

const TimelinePeriod = ({ timelinePeriod }) => {
  return (
    <div>
      <span className="mr-2 text-muted" style={{ fontSize: "0.9rem" }}>
        •
      </span>
      <span
        className="text-muted"
        style={{
          fontSize: "0.9rem",
        }}
      >
        {timelinePeriod}
      </span>
    </div>
  );
};

const WorkplaceDetails = ({ companyName, institutionType, companyLink }) => {
  return (
    <div className="mb-2">
      <i className="fa fa-building mr-2" />
      <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>
        {companyLink ? (
          <ReactRouterLink to={companyLink} target="_blank">
            {companyName}
          </ReactRouterLink>
        ) : (
          companyName
        )}
      </span>
      <span className="ml-1 mr-2 text-muted" style={{ fontSize: "0.75rem" }}>
        •
      </span>
      <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>
        {institutionType}
      </span>
    </div>
  );
};

const SeatDetails = ({ seat }) => {
  return (
    <div className="mb-2">
      <i className="fa fa-user mr-2" />
      <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>
        {seat}
      </span>
    </div>
  );
};

const RemunerationDetails = ({ remuneration }) => {
  return (
    <div className="d-flex align-items-baseline mb-2">
      <i className="fa fa-dollar-sign mr-2" />
      <p className="text-muted mr-2" style={{ fontSize: "0.8rem", margin: 0 }}>
        Remuneration:
      </p>
      <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>
        {remuneration ? toCurrency(remuneration) : "N/A"}
      </span>
    </div>
  );
};

const MarketCapDetails = ({ marketCap }) => {
  return (
    <div className="d-flex align-items-baseline mb-2">
      <i className="fa fa-chart-line mr-2 " />
      <p
        className="text-muted mr-2"
        style={{ fontSize: "0.8rem", margin: "0" }}
      >
        Market Cap:
      </p>
      <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>
        {marketCap ? formatMarketCap(marketCap) : "N/A"}
      </span>
    </div>
  );
};

const DetailsContainer = ({ children }) => {
  return <div className="pl-4 d-flex flex-column mt-2">{children}</div>;
};

export const CardCompanyDetails = ({ role, idx, dataLength }) => {
  return (
    <li
      key={role.id || idx}
      className={`py-1  ${
        idx !== dataLength - 1 ? "border-bottom border-light" : ""
      }`}
    >
      <TimelinePeriod
        timelinePeriod={`${formatSimpleDate(role.start_date)} – ${
          role.end_date ? formatSimpleDate(role.end_date) : "N/A"
        }`}
      />

      <DetailsContainer>
        <SeatDetails seat={role?.seat_name || "N/A"} />

        <WorkplaceDetails
          companyName={role?.name || "N/A"}
          companyLink={role?.link}
          institutionType={role?.institution_type || "N/A"}
        />

        <RemunerationDetails remuneration={role?.remuneration} />

        {role?.institution_type === "Listed" && (
          <MarketCapDetails marketCap={role?.market_capital} />
        )}
      </DetailsContainer>
    </li>
  );
};
